export const validations = {
  required: (message) => ({
    required: true,
    message,
  }),
  maxLength: (max, message) => ({
    max,
    message,
  }),
  email: (message) => ({
    type: 'email',
    message,
  }),
  noSpaces: (message) => ({
    validator: (_, value) => {
      if (!value || typeof value !== 'string') {
        return Promise.resolve(); // Allow empty or non-string values
      }
      return value.trim() !== ''
        ? Promise.resolve()
        : Promise.reject(new Error(message));
    },
  }),
  minValue: (min, message) => ({
    validator: (_, value) =>
      value && Number(value) >= min
        ? Promise.resolve()
        : Promise.reject(new Error(message)),
  }),
  validNumber: (message) => ({
    validator: (_, value) =>
      !isNaN(value) ? Promise.resolve() : Promise.reject(new Error(message)),
  }),
  maxLengthWithTrim: (max, message) => ({
    validator: (_, value) =>
      value && value.trim().length <= max
        ? Promise.resolve()
        : Promise.reject(new Error(message)),
  }),
  maxValue: (max, message) => ({
    validator: (_, value) =>
      value && Number(value) <= max
        ? Promise.resolve()
        : Promise.reject(new Error(message)),
  }),
  minLength: (min, message) => ({
    validator: (_, value) =>
      value && value.length >= min
        ? Promise.resolve()
        : Promise.reject(new Error(message)),
  }),
  indianMobile: (message) => ({
    pattern: /^\d{10}$/, // Only checks for 10 digits
    message,
  }),
  turkishMobile: (message) => ({
    pattern: /^\d{10}$/, // Only checks for 10 digits
    message,
  }),
  phoneNumber: (message) => ({
    validator: (_, value) => {
      if (!value) return Promise.resolve(); // Optional field
      const isValid = /^\d{10}$/.test(value); // Only checks for 10 digits
      return isValid ? Promise.resolve() : Promise.reject(new Error(message));
    },
  }),
  nameOnly: (message) => ({
    validator: (_, value) => {
      if (!value) return Promise.resolve(); // Allow empty values (handled by required)
      // Allow letters, spaces, hyphens, and common name characters including Turkish letters (ö, ğ, ş, ü, ç, ı, İ, Ö, Ğ, Ş, Ü, Ç)
      const isValid = /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF\u0130\u0131\u011E\u011F\u015E\u015F\u00D6\u00F6\u00DC\u00FC\u00C7\u00E7\s-]+$/.test(value.trim());
      return isValid ? Promise.resolve() : Promise.reject(new Error(message));
    },
  }),
  provinceCode: (message) => ({
    validator: (_, value) => {
      if (!value) return Promise.resolve(); // Allow empty values (handled by required)
      // Ensure value is a string before calling trim
      const trimmedValue = typeof value === 'string' ? value.trim() : String(value).trim();
      // Only allow numeric strings (with optional leading zeros like "01", "02", etc.)
      if (!/^\d+$/.test(trimmedValue)) {
        return Promise.reject(new Error(message));
      }
      // Convert to number to check range (handles both "01" and "1" formats)
      const numericValue = Number(trimmedValue);
      // Allow codes from 1 to 91 (including 01-09 with leading zero)
      if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 91) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(message));
    },
  }),
};
